module.exports = __webpack_public_path__ + "static/media/ss-angular-schedule-compare.a69a2ebb.gif";